import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import FormLayout from 'components/FormLayout';
import Form from 'components/Form';
import FormItem from 'components/FormItem';
import TextField from 'components/TextField';
import assistentAPI from 'apis/AssistentAPI';

function LogIA(){
  const form = useForm();

  const { guid } = useParams();
  const { control, reset } = form;
 
  useEffect(() => {
    assistentAPI.getQuestionByGuid({ guid: guid })
    .then((resp) => {
      try{
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(`<body>${resp.resposta}</body>`,"text/xml");
        let fieldValue = xmlDoc.getElementsByTagName('resposta')[0].childNodes[0].nodeValue.slice(1);

        resp.resposta = fieldValue;
        reset(resp);
      } catch(_e){
        alert("Erro ao processar a resposta da IA.");
      };
    });
  }, [guid, reset]);

  return(
    <Form>
      <FormLayout form={form}>
        <Grid item container spacing={2}>
          <FormItem xs={6} label="Usuário" name={"usuario"} size="small" control={control}>
            <TextField disabled/>
          </FormItem>
          <FormItem xs={6} label="Empresa" name={"cliente"} control={control}>
            <TextField disabled/>
          </FormItem>
          <FormItem xs={12} label={"Pergunta"} name={"pergunta"} control={control}>
            <TextField multiline rows={2} size="small" disabled/>
          </FormItem>
          <FormItem xs={12} label="Resposta" name={"resposta"} control={control}>
            <TextField label="Resposta" multiline rows={15} size="small" disabled/>
          </FormItem>
        </Grid>
      </FormLayout>
    </Form>
  );
};
export default LogIA;